<template>
  
  <div>
        
    <ring-loader v-if="showLoader"></ring-loader>

      <div ref="attendeeCardRef" class="bg-green-300 flex felx-col justify-center rounded lg:rounded-lg text-xs border-4 border-pink-600 w-full">

        <div class="flex flex-col content-around px-2">

            <div class="flex flex-col justify-around content-around">

                <div class="flex justify-center mt-2 lg:mt-5">

                    <img :src="player.two_player.picture" class="object-contain rounded-lg lg:rounded-full w-16 h-12 lg:w-24 lg:h-16">
                </div>

                <div class="flex mb-2 lg:mb-5 flex-col justify-around items-center">

                    <div class="flex flex-col items-center mt-4 lg:mt-10">

                        <!-- <div>

                            <label class="font-bold mr-1 lg:mr-5"> {{$t('player.playerName')}} </label>
                        </div> -->

                        <div class="mt-2 lg:mt-4">

                            <label class="bg-blue-300 p-1 lg:p-4 rounded lg:rounded-full border-blue-800
                            border lg:border-2 w-20 lg:w-32"> {{player.two_player.nickname}} </label>
                        </div>
                    </div>  
                </div>

                <!-- To Do Position-->
                <!-- <div class="flex flex-col justify-around w-full">
            
                    <div class="flex">
                        
                        <div>

                            <label>{{$t('player.firstPosition')}}</label>
                        </div>

                        <div class="">
                                            
                            <label v-if="$i18n.locale == 'ar'"> {{player.two_player.position_one.name_ar}} </label>
                            <label v-else> {{player.two_player.position_one.name}} </label>
                        </div>
                    </div>

                    <div class="flex">

                        <div>

                            <label>{{$t('player.secondPosition')}}</label>
                        </div>

                        <div class="">
                           
                            <label v-if="$i18n.locale == 'ar'"> {{player.two_player.position_two.name_ar}} </label>
                            <label v-else> {{player.two_player.position_two.name}} </label>
                        </div>
                    </div>
                </div> -->
            </div>

            <div class="mt-2 lg:mt-4 mb-2 lg:mb-4 flex justify-around items-center">

                <div class="mr-1 lg:mr-2">

                    <button :href="`tel:${player.two_player.phone}`" 
                    class="rounded-full bg-blue-400 text-white border border-blue-600 w-10 lg:w-16">
                        {{$t('player.call')}}</button>
                </div>

                <div class="w-12">

                    <a :href="`https://wa.me/${player.two_player.phone}`">
                    <button><img class="object-scale-down rounded lg:rounded-lg w-8 h-6 lg:w-12 lg:h-10"
                     src="@/assets/images/whatsapp.png" alt="whatsapp">
                    </button>
                    </a>
                </div>
            </div>


                <div class="flex flex-col justify-center items-center text-xs lg:text-lg mt-1 lg:mt-2 mb-1 lg:mb-2 w-full" v-if="showFootballPositions">

                    <div class="flex mb-1 lg:mb-2">

                        <div class="border bg-blue-100 rounded lg:rounded-lg lg:bg-blue-200 lg:border-2 ">

                            <label v-if="$i18n.locale == 'ar'">{{player.two_player.position_one.name_ar}}</label>
                            <label v-else>{{player.two_player.position_one.name}}</label>
                        </div>
                    </div>

                    <div class="flex mb-1 lg:mb-2">

                        <div class="border bg-blue-100 rounded lg:rounded-lg lg:bg-blue-200 lg:border-2">

                            <label v-if="$i18n.locale == 'ar'">{{player.two_player.position_two.name_ar}}</label>
                            <label v-else>{{player.two_player.position_two.name}}</label>
                        </div>
                    </div>
                </div>

            <div v-if="allowEdit && showButtons" class="flex justify-around items-center">

                <div v-if="player.team != 1" class="mr-1 lg:mr-2">

                    <button  @click="callSwitchToTeam(1)"
                    class="rounded-full bg-yellow-400 text-white border border-yellow-600 w-12 lg:w-12">
                        {{$t('player.teamOne')}} </button>
                </div>

                <div v-if="player.team != 0" class="mr-1 lg:mr-2">

                    <button  @click="callSwitchToTeam(0)"
                    class="rounded-full bg-purple-400 text-white border border-purple-600 w-12 lg:w-12">
                        {{$t('player.remove')}} </button>
                </div>

                <div  v-if="player.team != 2" class="w-12">

                    <button @click="callSwitchToTeam(2)"
                    class="rounded-full bg-red-400 text-white border border-red-600 w-12 lg:w-12">
                        {{$t('player.teamTwo')}}</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import twoMyUpdates from '../hasura/myTwoUpdates';

import twoMyQueries from '../hasura/myTwoQueries';

import componentsHelpers from '../classes/componentHelpers';

export default {

    created(){

        // console.log(`in player card, player: ${JSON.stringify(this.player)}`);
    },

    mounted(){

        // console.log(`in player card, player: ${JSON.stringify(this.player)}`);

        // console.log(`in player card, playerId: ${this.playerId}`);
    },

    props:{

        showFootballPositions: false,

        groupId: 0,

        player: {

            type: Object
        },

        mainCard: false,

        playerId: 0,

        allowEdit: false,

        switchToTeam: {

            type: Function
        }
    },

    computed:{

        showButtons(){

            // console.log(`this.mainCard: ${this.mainCard}`);

            if(this.mainCard)
            {     
                
                // console.log(`this.mainCard: ${this.mainCard} == true `);

                if(this.player.team == 1 || this.player.team == 2)
                {
                    
                    // console.log(`if is false`);

                    return false;
                }
                else{

                    // console.log(`if is true`);
                   
                    return true;
                }
            }
            
            return true;
        }
    },

    methods:{

        changeLoader(value){

            this.showLoader = value;
        },

        callSwitchToTeam(newTeam){
            
            console.log(`player: ${JSON.stringify(this.player.two_player)}`)

            console.log(`id: ${this.player.two_player.id}, player.nickname: ${this.player.two_player.nickname}`);

            // console.log(`this.playerId: ${this.playerId}`)

            console.log(`oldTeam: ${this.player.team}, newTeam: ${newTeam}`)

            this.switchToTeam(this.player.team, newTeam, this.player.two_player.id, this.changeLoader);
        }
    },

    data: function(){

        return{

            showLoader: false,
            // showButtons: true,
        }
    }
}
</script>

<style>

</style>